import { isSpecialPointReward } from "@/components/Ui/Label/Rewards/utils";
import type { Networkish, SupSingleVaultV3, SupVaultReward } from "@/types";
import React from "react";

import { CRED_REWARD, CRED_SUPERVAULT_REWARD } from "@/components/Ui/Label/Rewards/constant";
import UiLabelRewardsTooltip from "@/components/Ui/Label/Rewards/Tooltip";

import { SupAvatar, SupAvatarGroup, SupTooltip } from "@repo/core-ui";

interface GridCellAccountPositionRewardsProps {
  singlePosition: {
    vault: SupSingleVaultV3;
    chain_id: Networkish;
  };
}

export default function GridCellAccountPositionRewards({ singlePosition }: GridCellAccountPositionRewardsProps) {
  const rewardsArray = [isSpecialPointReward(singlePosition.vault) ? CRED_SUPERVAULT_REWARD : CRED_REWARD] as SupVaultReward[];

  if (singlePosition.vault.rewards !== null) {
    rewardsArray.push(...singlePosition.vault.rewards);
  }
  return (
    <div className="flex items-center px-[28px] py-[21px]">
      <SupTooltip
        unmount
        portal
        wrapper
        content={<UiLabelRewardsTooltip showCred vault={singlePosition.vault} period="month" useFallback={false} />}
        popperElClassName="max-w-fit px-2 py-4 bg-neutral-25"
        color="default"
      >
        <SupAvatarGroup border="ring" max={6} variant="circular" className="-space-x-4">
          {rewardsArray.map((reward, index) => (
            <SupAvatar key={`earning-cell-${singlePosition.chain_id}-${singlePosition.vault.id}-${reward.type}-${reward.address}-${index}`}>
              <img src={reward.logo} alt={reward.symbol} className="bg-neutral-50" />
            </SupAvatar>
          ))}
        </SupAvatarGroup>
      </SupTooltip>
    </div>
  );
}
